import { CatalogApi } from '@backstage/plugin-catalog-react';
import { AppExtensionsApi } from './AppExtensionsApi';
import { AppExtensionManifest } from '../types';
import { entityToManifest } from './entityToManifest';

const APP_EXTENSION_KIND = 'AppExtension';
const DEFAULT_NAMESPACE = 'default';

/**
 * AppExtensionsApi implementation querying the Backstage software catalog
 * directly (kind: AppExtension) — the standard way to read a custom entity
 * kind from the frontend, same as every other entity list/detail view in
 * this app. No bespoke backend REST API needed just to reshape catalog data.
 */
export class CatalogAppExtensionsClient implements AppExtensionsApi {
  constructor(private readonly catalogApi: CatalogApi) {}

  async listAppExtensions(): Promise<AppExtensionManifest[]> {
    const { items } = await this.catalogApi.getEntities({
      filter: { kind: APP_EXTENSION_KIND },
    });
    return items
      .map(entityToManifest)
      .filter((manifest): manifest is AppExtensionManifest => !!manifest);
  }

  async getAppExtension(
    extensionId: string,
  ): Promise<AppExtensionManifest | undefined> {
    const entity = await this.catalogApi.getEntityByRef({
      kind: APP_EXTENSION_KIND,
      namespace: DEFAULT_NAMESPACE,
      name: extensionId,
    });
    return entity ? entityToManifest(entity) : undefined;
  }
}
